export default {
  isLogged(state, getters) {
    return Boolean(getters.isAuthenticated && getters['user/user']);
  },
  hasLoggedUser(state, getters) {
    return Boolean(getters['user/user']);
  },
};
